module.exports = __webpack_public_path__ + "static/img/11.6650775.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/app/11.jpg
// module id = 1IZE
// module chunks = 36